import styled from "styled-components";

export const RadioWrapper = styled.div`
  display: flex;
  align-items: center;

  input {
    cursor: pointer;
  }

  > div {
    margin-left: 8px;
    margin-bottom: 0px;
  }
  pointer-events: ${p => (p.disabled ? "none" : "auto")};
  opacity: ${p => (p.disabled ? 0.5 : 1)};
`;

export const SelectedContentContainer = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-top: 16px;
`;

export const IncludedContentHeader = styled.div`
  margin-top: 17px;
  margin-bottom: 12px;
  display: flex;
  color: #2a2a3d;
  font-family: "MaisonNeue", "Helvetica Neue", Helvetica, Arial, sans-serif;
  font-size: 10px;
  font-weight: 700;
  letter-spacing: 0.8px;
`;

export const SearchInput = styled.div`
  background-color: #ffffff;
  border: 1px solid ${props => (props.open ? "#5d69e6" : "#ebeafb")};
  border-radius: 2px;
  border-bottom-left-radius: ${props => (props.open ? "0px" : null)};
  border-bottom-right-radius: ${props => (props.open ? "0px" : null)};
  border-bottom: ${props => (props.open ? "none !important" : null)};
  padding-bottom: ${props => (props.open ? "1px" : null)};
  box-sizing: border-box;
  height: 50px;
  color: #2a2a3d;
  font-size: 14px;
  font-weight: 500;
  padding-left: 20px;
  padding-right: 20px;

  display: flex;
  align-items: center;
  height: 40px;
  width: 460px;
  box-sizing: border-box;

  &:focus-within {
    border: 1px solid #5d69e6;
    color: #2a2a3d;
    outline: none;
  }

  & input {
    border: none;
    padding-left: 12px;
    width: 100%;
    line-height: 19px;

    &:focus {
      outline: none;
      box-shadow: none;
    }

    &::-webkit-input-placeholder {
      color: #9b9bc2;
      font-weight: 400;
    }

    &::-moz-placeholder {
      color: #9b9bc2;
      font-weight: 400;
    }

    &:-ms-input-placeholder {
      color: #9b9bc2;
      font-weight: 400;
    }

    &:-moz-placeholder {
      color: #9b9bc2;
      font-weight: 400;
    }
  }
`;

export const IncludedContentList = styled.div`
  display: flex;
  flex-direction: column;
  // Should be able to show a little more than half of a third item
  height: 100px;
  min-height: 100px;
  overflow: scroll;
`;

export const IncludedContentListItem = styled.div`
  display: flex;
  align-items: center;
  color: #191919;
  font-family: "Helvetica Neue", Helvetica, Arial, sans-serif;
  font-size: 12px;
  font-weight: 400;
  border-top: 1px solid #ececf5;
  height: 40px;
  min-height: 40px;

  &:last-child {
    border-bottom: 1px solid #ececf5;
  }
`;

export const IncludedContentName = styled.div`
  width: 170px;
  margin-right: 100px;
`;

export const IncludedContentType = styled.div`
  width: 45px;
  margin-right: 100px;
`;

export const IncludedContentDelete = styled.div`
  width: 45px;
  display: flex;
  justify-content: center;
  cursor: pointer;
`;

export const Menu = styled.div`
  position: absolute;
  top: 40px;
  display: ${props => (props.open ? "flex" : "none")};
  flex-direction: column;
  box-sizing: border-box;
  width: 460px;
  z-index: 1;

  border: 1px solid #5d69e6;
  border-bottom-left-radius: 2px;
  border-bottom-right-radius: 2px;
  border-top: none;
  background: #ffffff;

  // Should be able to show a little more than half of a sixth item
  max-height: 235px;
  overflow: scroll;
`;

export const MenuItem = styled.div`
  border-top: 1px solid rgba(235, 234, 251, 0.5);
  padding: 12px 16px 12px 20px;
  display: ${props => (props.isLoadingSpinner ? "flex" : null)};
  justify-content: ${props => (props.isLoadingSpinner ? "center" : null)};

  &:hover {
    background-color: rgba(0, 0, 0, 0.05);
  }
`;
